import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Button, IconButton, Stack, Typography } from '@mui/material';
import { blueGrey, grey } from '@mui/material/colors';
import { GridRenderCellParams } from "@mui/x-data-grid";
import { useState } from 'react';

export function RenderPassword(params: GridRenderCellParams) {
	const [isVisible, setIsVisible] = useState(false);

	if (params.value == null) {
		return '';
	}

	function ToggleVisibility() {
		setIsVisible(!isVisible);
	}

	return (
		<Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} height={"100%"}>
			{isVisible ?
				<Typography>{params.value}</Typography>
				:
				<Typography>{"*".repeat(params.value.length)}</Typography>
			}
			<Button
				onClick={ToggleVisibility}
				variant='text'
				sx={{
					padding: 0,
					minWidth: 0,
					"&:hover": {
						bgcolor: "initial"
					}
				}}>
				{isVisible ?
					<VisibilityIcon sx={{
						color: grey[500],
						"&:hover": {
							color: grey[600]
						},
					}}>
					</VisibilityIcon>
					:
					<VisibilityOffIcon sx={{
						color: grey[300],
						"&:hover": {
							color: grey[400]
						},
					}}></VisibilityOffIcon>
				}
			</Button>
		</Stack>
	);
}